export default '/build/c8e68150.png'